import { TopLevelOrderStatus } from '@/api/generated-catch-backend/model';
import { useListLabOrdersV1LabsOrdersGet } from '@/api/generated-catch-backend/laboratory-orders/laboratory-orders';

/**
 * Shared hook for lab order eligibility.
 * Returns whether the user is eligible to place a new lab order,
 * based on the top-level status from the lab orders API.
 */
export function useIsEligibleForLabOrder() {
  const { data: labOrdersData, isLoading } = useListLabOrdersV1LabsOrdersGet();

  const isEligibleForLabOrder = labOrdersData?.meta?.status === TopLevelOrderStatus.eligible;

  return { isEligibleForLabOrder, isLoading, labOrdersData };
}
